import { createAction, props } from '@ngrx/store';

export const loadUserPredictions = createAction(
  '[Prediction] Load User Predictions',
  props<{ userId: string }>()
);
export const loadUserPredictionsSuccess = createAction(
  '[Prediction] Load User Predictions Success',
  props<{ predictions: any[] }>()
);
export const loadUserPredictionsFailure = createAction(
  '[Prediction] Load User Predictions Failure',
  props<{ error: any }>()
);

export const loadUserHistoryPredictions = createAction(
  '[Prediction] Load History Predictions',
  props<{ userId: string }>()
);
export const loadUserHistoryPredictionsSuccess = createAction(
  '[Prediction] Load History Predictions Success',
  props<{ predictions: any[] }>()
);
export const loadUserHistoryPredictionsFailure = createAction(
  '[Prediction] Load History Predictions Failure',
  props<{ error: any }>()
);


export const loadPredictionDetails = createAction(
  '[Prediction] Load Prediction Details',
  props<{ predictionId: string, userId: string }>()
)

export const loadPredictionDetailsSuccess = createAction(
  '[Prediction] Load Prediction Details Success',
  props<{ prediction: any[] }>()
);
export const loadPredictionDetailsFailure = createAction(
  '[Prediction] Load Prediction Details Failure',
  props<{ error: any }>()
);


export const createPrediction = createAction(
  '[Prediction] Create Prediction',
  props<{
    title: string;
    sport: number;
    competition: number;
    team_home: number;
    team_away: number;
    confidence_team_home: number;
    confidence_team_away: number;
    event_name: string;
    event_date: Date; 
    analysis_text: string;
    created_by: number;
    price_jetons: number;
    cote: string;
    is_prediction_purchased?: boolean; 
  }>()
);

export const createPredictionSuccess = createAction(
  '[Prediction] Create Prediction Success'
);
export const createPredictionFailure = createAction(
  '[Prediction] Create Prediction Failure',
  props<{ error: any }>()
);

export const deletePrediction = createAction(
  '[Prediction] Delete Prediction',
  props<{ predictionId: string }>()
);
export const deletePredictionSuccess = createAction(
  '[Prediction] Delete Prediction Success'
);
export const deletePredictionFailure = createAction(
  '[Prediction] Delete Prediction Failure',
  props<{ error: any }>()
);


